import script from "./dashbSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashbSettings.vue?vue&type=script&setup=true&lang=ts"

import "./dashbSettings.vue?vue&type=style&index=0&id=c38cde1c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c38cde1c"]])

export default __exports__